import { DocumentFormBuilderComponent } from "./document-form-builder.component";
import { OnInit } from "@angular/core";
import { ClaimTypes } from "../../model/claim-type.model";
import { DocumentField } from "../../model/document-field";
import { Claim } from "../../model/claim.model";
import { SmartqDocuments } from "../../model/smartq-documents.model";
import { UtilitiesService } from "../../utilities/utilities.service";

export class DeathAndSeriousFormBuilder extends DocumentFormBuilderComponent implements OnInit {
    constructor(claim: Claim){
        super(claim);
        this.documentFormClaimType = ClaimTypes[ClaimTypes.CLAIM_TYPE_MED_DTH];
    }

    setRequiredDocuments(){
        let requiredDocuments: DocumentField[] = [];
        if (this.claim.getClaimTravel().getGBAPlanType()) {
            requiredDocuments.push(new DocumentField('PROOFTRAVEL', 'claimSection.greaterBayArea.proofOfTravel', SmartqDocuments.PROOF_TRAVEL, true));
        } else {
            requiredDocuments.push(new DocumentField('AIRTICKET', 'pageSummaryClaim.claimItem.sectionDeath.subSupportingDocs.copyTicket', SmartqDocuments.AIRTICKET, true));
        }
        if(this.claim.getClaimTravel().getDeathAndSeriousBodyInjuryLoss().getWasMugging()){
            requiredDocuments.push(new DocumentField('POLICEREPORT', 'pageSummaryClaim.claimItem.sectionDeath.subSupportingDocs.policeReport', SmartqDocuments.REPORT, true));
        }
        let injuryType = this.claim.getClaimTravel().getDeathAndSeriousBodyInjuryLoss().getNatureOfIllness();
        if ((injuryType != undefined) && (injuryType.toUpperCase().indexOf("DEATH") !== -1)) {
            requiredDocuments.push(new DocumentField('DEATHCERT', 'pageSummaryClaim.claimItem.sectionDeath.subSupportingDocs.deathCert', SmartqDocuments.LEGALDOCUMENT, true));
        } 
        requiredDocuments.push(new DocumentField('MEDICALREPORT', 'pageSummaryClaim.claimItem.sectionDeath.subSupportingDocs.medReport', SmartqDocuments.MEDICALREPORT, true));
        let medBills = parseInt(this.claim.getClaimTravel().getDeathAndSeriousBodyInjuryLoss().getNumberOfTreatmentBill());
        if(!isNaN(medBills) && medBills > 0){
            for(let x = 1; x < medBills + 1; x++){
                requiredDocuments.push(new DocumentField('MEDICALBILL' + String.fromCharCode(x+64), 'pageSummaryClaim.claimItem.sectionDeath.subSupportingDocs.medBills', SmartqDocuments.INVOICE, true));
            }
        }
        if(this.claim.getClaimTravel().getDeathAndSeriousBodyInjuryLoss().getHasReceiveFollowUpTreament()){
            requiredDocuments.push(new DocumentField('RECEIPTFOLLOWUP', 'pageSummaryClaim.claimItem.sectionDeath.subSupportingDocs.receiptTreat', SmartqDocuments.INVOICE, true));
        }
        if(UtilitiesService.isMinor(this.claim.getClaimantDateOfBirth())){
            requiredDocuments.push(new DocumentField('PROOFOFREL', 'pageSummaryClaim.claimItem.miscDoc', SmartqDocuments.LEGALDOCUMENT, true));
        }
        this.requiredDocuments = requiredDocuments;
    }
}